<script lang="ts" setup>
import { ChatInputInstance } from "@/components/mobile/chat/mission/MissionDialogueInput.vue";
import { InputTypeEnum } from "@/enums/chatEnums";
import { useGlobalModal } from "@/stores/globalModal";
import { ChatMessage, Mate, MateDispatch } from "@/types/entity.d";
import { computed, onMounted, ref } from "vue";
// Props & Emit
const props = withDefaults(
  defineProps<{
    enableHistoryMode?: boolean;
    mate: Mate;
    dispatch: MateDispatch;
    isPrivate: boolean;
    isHistoryMode?: boolean;
    isPostingMsg: "start" | "end" | false;
    isStreamReplying: boolean;
    myMessage: string;
    streamMsg: string;
    isInputFocus?: boolean;
    shouldLogin?: boolean;
    hideMsgUI?: boolean;
    enableAvatar?: boolean;
  }>(),
  {
    isHistoryMode: false,
    enableHistoryMode: false,
    isInputFocus: false,
    shouldLogin: false,
    hideMsgUI: false,
  }
);

const emit = defineEmits<{
  (
    e: "onStreamFinish",
    data: {
      userMsg: ChatMessage;
      assistantMsg?: ChatMessage;
    }
  ): void;
  (e: "onInputFocus"): void;
  (e: "update:isHistoryMode", value: boolean): void;
  (e: "update:isPostingMsg", value: "start" | "end" | false): void;
  (e: "update:isStreamReplying", value: boolean): void;
  (e: "update:myMessage", value: string): void;
  (e: "update:streamMsg", value: string): void;
  (e: "update:isInputFocus", value: boolean): void;
  (e: "update:hideMsgUI", value: boolean): void;
  (e: "onPostMsgClick", toNames?: string[]): void;
  (e: "update:enableAvatar", value: boolean): void;
}>();
// Constant
const ChatActions = ref([
  {
    icon: "mingcute--chat-3-line",
    label: "Chats.actions.say",
    value: InputTypeEnum.SAY,
  },
  // {
  //   value: InputTypeEnum.DO,
  //   label: "Chats.actions.do",
  //   icon: "mingcute--tool-line",
  // },
  {
    value: InputTypeEnum.SNEAK,
    label: "Chats.actions.sneak",
    icon: "mdi--eye-off",
  },
  {
    value: InputTypeEnum.MOVE,
    label: "Chats.actions.move",
    icon: "mingcute--walk-line",
  },
  {
    value: InputTypeEnum.FIGHT,
    label: "Chats.actions.fight",
    icon: "mingcute--sword-line",
  },
  // {
  //   icon: "mingcute--backpack-line",
  //   label: computed(() => t("Chats.actions.items")),
  //   value: InputTypeEnum.ITEM,
  // },
  // {
  //   icon: "mingcute--ai-line",
  //   label: computed(() => t("Chats.actions.mixed")),
  //   value: InputTypeEnum.MIXED,
  // },
]);
// State

const globalModal = useGlobalModal();

const inputMsg = ref<string>("");
const currentMsgType = ref<InputTypeEnum>(InputTypeEnum.SAY);
const actionTargets = ref<string[]>([]);
const inputPlaceholder = computed(() => {
  if (currentMsgType.value === InputTypeEnum.MESSAGE) return undefined;
  return ChatActions.value.find((type) => type.value === currentMsgType.value)
    ?.label;
});

const temperature = ref(0.35);

export interface ChatFooterInstance {
  postMessage: ChatInputInstance["postMessage"];
}

const chatInputRef = ref<ChatInputInstance | null>(null);

defineExpose({ postMessage: computed(() => chatInputRef.value?.postMessage) });

const isSayOrDo = computed(() =>
  [InputTypeEnum.SAY, InputTypeEnum.DO].includes(currentMsgType.value)
);

onMounted(() => {
  globalModal.openServerUpgradingModal();
});
</script>
<template>
  <div class="border-t">
    <MissionDialogueInput
      ref="chatInputRef"
      v-model:input-msg="inputMsg"
      v-show="isSayOrDo"
      :input-type="currentMsgType"
      :is-posting-message="isPostingMsg"
      :is-stream-replying="isStreamReplying"
      :mate="mate"
      :dispatch-uuid="dispatch.uuid"
      :my-message="myMessage"
      :placeholder="`回复${mate.name}`"
      :stream-msg="streamMsg"
      :temperature="temperature"
      :to-name="actionTargets"
      :enable-fast-forward="false"
      @blur="emit('update:isInputFocus', false)"
      @focus="
        emit('onInputFocus');
        emit('update:isInputFocus', true);
      "
      :enable-show-bottom-options="false"
      @update:is-posting-message="emit('update:isPostingMsg', $event)"
      @update:is-stream-replying="emit('update:isStreamReplying', $event)"
      @update:my-message="emit('update:myMessage', $event)"
      @update:stream-msg="emit('update:streamMsg', $event)"
      @on-stream-finish="emit('onStreamFinish', $event)"
      @on-post-msg-click="emit('onPostMsgClick', $event)"
    />
  </div>
</template>
<style scoped>
.chat-ghost-btn {
  @apply btn-xs lg:btn-sm btn backdrop-blur-md bg-black/30 text-white border-0 hover:bg-black/80;
}

.chat-ghost-btn.active {
  @apply bg-primary/80 hover:bg-primary;
}

.heart-icon-color:before {
  background-image: var(--colorful-gradient-r);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.chat-darken-linear-background-b {
  background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
}
</style>
